import { render, staticRenderFns } from "./TokenRevokeModal.vue?vue&type=template&id=d309f638&"
import script from "./TokenRevokeModal.vue?vue&type=script&lang=js&"
export * from "./TokenRevokeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports